//helpers:
import { getData, postData, putData, deleteData } from '../../dataLib';

import React, { Component } from 'react';
import { connect } from 'react-redux';
//import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';
import DatePicker from '../../components/utils/DatePicker';

//actions:
import { navigate, openDialog, hideDialog } from '../../actions';

import { setCentroDia } from '../../actions/centro_dia_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';


import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 800,
    },
});

class AccInventario extends Component {
    constructor(props) {
        super(props);

        let fend = new Date();
        let fini = new Date(
            fend.getFullYear() - 1,
            fend.getMonth(),
            fend.getDate(),
        );
        this.state = {
            inventarioList: [],
            fIni: fini.toISOString().slice(0, 10),
            fEnd: fend.toISOString().slice(0, 10),
            showSpinner: false,
        };
    }

    refresh(aCentroId, aFIni, aFEnd) {
        let request =
            'DCInventarios?centro_id=' +
            aCentroId +
            '&f_ini=' +
            aFIni +
            '&f_end=' +
            aFEnd;

        if (this.state.showSpinner !== true)
            this.setState({ ...this.state, showSpinner: true });

        getData(
            request,
            response => {
                this.setState({
                    ...this.state,
                    inventarioList: response.data.map(p => {
                        return {
                            ...p,
                            ft_fInventario: p.fInventario ? new Date(p.fInventario).toLocaleDateString('es-ES', { year: '2-digit', month: '2-digit', day: '2-digit' }) : '',
                            ft_fValidado: p.fValidado ? new Date(p.fValidado).toLocaleDateString('es-ES', { year: '2-digit', month: '2-digit', day: '2-digit' }) : '',
                            ft_fCerrado: p.fCerrado ? new Date(p.fCerrado).toLocaleDateString('es-ES', { year: '2-digit', month: '2-digit', day: '2-digit' }) : '',
                        }
                    }),
                    fIni: aFIni,
                    fEnd: aFEnd,
                    showSpinner: false,
                });
            },
            error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching inventario',
                    },
                    'acc_inventario',
                    false,
                    'sm',
                );
                this.setState({ ...this.state, showSpinner: false });
            },
            this.props.user,
        );
    }

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(''); //go to home page
            return;
        }

        this.refresh(
            this.props.centroId ? this.props.centroId : -1,
            this.state.fIni,
            this.state.fEnd,
        );
    }

    messageDialog = msg => {
        this.props.openDialog(
            'SimpleMessage',
            {
                message: msg,
            },
            uuidv4(),
            false,
            'sm',
        );
    };

    editInventario = inventario => {
        // indica si este es el último inventario cerrado
        const ultimoCerrado =
            inventario.bCerrado === true &&
            !this.state.inventarioList.find(
                p =>
                    p.centroId === inventario.centroId &&
                    p.bCerrado === true &&
                    p.fInventario > inventario.fInventario,
            );

        // indica si este es el primer inventario abierto
        const primeroAbierto =
            inventario.bCerrado === false &&
            !this.state.inventarioList.find(
                p =>
                    p.centroId === inventario.centroId &&
                    p.bCerrado === false &&
                    p.fInventario < inventario.fInventario,
            );

        // obtiene el inventario
        let URL = 'DCInventarios/' + inventario.id;

        this.setState({ ...this.state, showSpinner: true });

        getData(
            URL,
            response => {
                // Llama al dialog de edición
                this.setState({ ...this.state, showSpinner: false });
                // añadea a cada fila del inventario un campo para el contro del color
                // de las columnas
                const newList = response.data.lLineas.map(p => {
                    return { ...p, colColorTrue: true };
                });

                this.props.openDialog(
                    'EditInventario',
                    {
                        inventario: { ...response.data, lLineas: newList },
                        user: this.props.user,
                        iPerfil: this.props.iPerfil,
                        ultimoCerrado: ultimoCerrado,
                        primeroAbierto: primeroAbierto,

                        okHandler: a_inventario => {
                            const newArr = this.state.inventarioList.map(p => {
                                if (p.id === a_inventario.id) {
                                    p.fValidado = a_inventario.fValidado;
                                    p.fInventario = a_inventario.fInventario;
                                }
                                return p;
                            });
                            this.setState({
                                ...this.state,
                                inventarioList: newArr,
                            });

                            this.updateDB(a_inventario);
                        },

                        cierraInventarioHandler: a_inventario => {
                            const newArr = this.state.inventarioList.map(p => {
                                if (p.id === a_inventario.id) {
                                    p.bCerrado = true;
                                    p.fCerrado = new Date()
                                        .toISOString()
                                        .slice(0, 10);
                                }
                                return p;
                            });
                            this.setState({
                                ...this.state,
                                inventarioList: newArr,
                            });

                            this.cierraInventarioDB(a_inventario);
                        },

                        abreInventarioHandler: a_inventario => {
                            const newArr = this.state.inventarioList.map(p => {
                                if (p.id === a_inventario.id) {
                                    p.bCerrado = false;
                                    p.fCerrado = {};
                                }
                                return p;
                            });
                            this.setState({
                                ...this.state,
                                inventarioList: newArr,
                            });

                            this.abreInventarioDB(a_inventario);
                        },

                        openDialog: this.props.openDialog,
                        hideDialog: this.props.hideDialog,
                    },
                    uuidv4(),
                    true,
                    'md',
                );
            },
            error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching inventario',
                    },
                    'edit_inventario',
                    false,
                    'sm',
                );
                this.setState({ ...this.state, showSpinner: false });
            },
            this.props.user,
        );
    };

    newInventario = () => {
        // indica si este es el último inventario cerrado
        const ultimoCerrado = false; // porque no está cerrado
        // indica si este es el primer inventario abierto
        const primeroAbierto =
            !this.state.inventarioList.find(
                p =>
                    p.centroId === this.props.centroId &&
                    p.bCerrado === false &&
                    p.fInventario < new Date(),
            );

        // obtiene un nuevo inventario
        let URL =
            'DCInventarios/new?centro_id=' +
            this.props.centroId +
            '&f_inventario=' +
            new Date().toISOString().slice(0, 10) +
            '&usuario_id=' +
            this.props.user.profile.sub; // esto es el usuario_id!!!

        this.setState({ ...this.state, showSpinner: true });

        getData(
            URL,
            response => {
                // Llama al dialog de edición
                this.setState({ ...this.state, showSpinner: false });

                this.props.openDialog(
                    'EditInventario',
                    {
                        inventario: response.data,
                        user: this.props.user,
                        iPerfil: this.props.iPerfil,

                        ultimoCerrado: ultimoCerrado,
                        primeroAbierto: primeroAbierto,
                        //okHandler: this.updateDB,
                        okHandler: a_inventario => {
                            const newArr = this.state.inventarioList.map(p => {
                                if (p.id === a_inventario.id) {
                                    p.fValidado = a_inventario.fValidado;
                                    p.fInventario = a_inventario.fInventario;
                                }
                                return p;
                            });
                            this.setState({
                                ...this.state,
                                inventarioList: newArr,
                            });

                            this.updateDB(a_inventario);
                        },

                        cierraInventarioHandler: a_inventario => {
                            const newArr = this.state.inventarioList.map(p => {
                                if (p.id === a_inventario.id) {
                                    p.bCerrado = true;
                                    p.fCerrado = new Date()
                                        .toISOString()
                                        .slice(0, 10);
                                }
                                return p;
                            });
                            this.setState({
                                ...this.state,
                                inventarioList: newArr,
                            });

                            this.cierraInventarioDB(a_inventario);
                        },

                        abreInventarioHandler: a_inventario => {
                            this.props.openDialog('SimpleMessage', { message: 'Internal error: no debe abrirse un inventario abierto', }, 'edit_inventario', false, 'sm');
                        },
                        openDialog: this.props.openDialog,
                    },
                    uuidv4(),
                    true,
                    'md',
                );
            },
            error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching new inventario',
                    },
                    'edit_inventario',
                    false,
                    'sm',
                );
                this.setState({ ...this.state, showSpinner: false });
            },
            this.props.user,
        );
    };

    updateDB = a_inventario => {
        this.setState({ ...this.state, showSpinner: true });

        a_inventario.usuarioId = this.props.user.profile.sub;
        postData(
            'DCInventarios',
            response => {
                if (a_inventario.id === 0) {
                    this.messageDialog('Inventario guardado');
                    this.refresh(
                        this.props.centroId,
                        this.state.fIni,
                        this.state.fEnd,
                    );
                } else {
                    this.messageDialog('Inventario actualizado');
                    this.setState({ ...this.state, showSpinner: false });
                }
            },
            () => {
                this.setState({ ...this.state, showSpinner: false });
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR actualizando inventario',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            a_inventario,
            this.props.user,
        );
    };

    cierraInventarioDB = a_inventario => {
        this.setState({ ...this.state, showSpinner: true });
        putData(
            'DCInventarios/cierra?inventario_id=' +
            a_inventario.id +
            '&usuario_id=' +
            this.props.user.profile.sub,
            response => {
                this.setState({ ...this.state, showSpinner: false });
                this.messageDialog('Inventario cerrado');
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'error cerrando el inventario',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            a_inventario,
            this.props.user,
        );
    };

    abreInventarioDB = a_inventario => {
        this.setState({ ...this.state, showSpinner: true });
        putData(
            'DCInventarios/abre?inventario_id=' +
            a_inventario.id +
            '&usuario_id=' +
            this.props.user.profile.sub,
            response => {
                this.setState({ ...this.state, showSpinner: false });
                this.messageDialog('Inventario abierto');
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'error abriendo el inventario',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            a_inventario,
            this.props.user,
        );
    };

    deleteInventario = inventario => {
        if ([0, 4, 5, 17, 20].includes(this.props.iPerfil)) {
            this.props.openDialog(
                'ConfirmationDialog',
                {
                    message:
                        '¿Desea eliminar el inventario de ' +
                        this.state.inventarioList
                            .find(c => inventario.id === c.id)
                            .fInventario.slice(0, 10) +
                        ' ?',
                    acceptHandler: () => {
                        this.setState({ ...this.state, showSpinner: true });
                        deleteData(
                            'DCInventarios/' + inventario.id,
                            response => {
                                this.setState({
                                    ...this.state,
                                    inventarioList: this.state.inventarioList.filter(
                                        p => p.id !== inventario.id,
                                    ),
                                    showSpinner: false,
                                });
                                this.messageDialog('Inventario borrado');
                            },
                            () => {
                                this.props.openDialog(
                                    'SimpleMessage',
                                    {
                                        message: 'error borrando el inventario',
                                    },
                                    uuidv4(),
                                    false,
                                    'sm',
                                );
                            },
                            this.props.user,
                        );
                    },
                },
                uuidv4(),
                false,
                'sm',
            );
        }
    };

    // ddw centros events
    centroSelectList = () => {
        return this.props.centros
            .filter(c => c.activo === 1)
            .map((centro, index) => {
                return (
                    <option key={centro.id} value={centro.id}>
                        {centro.centro}
                    </option>
                );
            });
    };

    handleChangeSelectCentro = event => {
        this.refresh(
            event.target.value ? event.target.value : -1,
            this.state.fIni,
            this.state.fEnd,
        );

        if (event.target.value)
            this.props.setCentroDia(event.target.value, undefined, false);
    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    render() {
        const { classes } = this.props;

        if (this.state.showSpinner === true)
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress
                        className={classes.spinner}
                        color="primary"
                    />
                </div>
            );
        else {
            return (
                <div className={classes.root}>
                    <div className={classes.toolbar} />

                    <div
                        style={{ marginBottom: 20, marginLeft: 20 }}
                        className={classes.containerPair}
                    >
                        {this.props.centros &&
                            [0, 4, 5, 16, 17, 20].includes(this.props.iPerfil) &&
                            this.props.kd === undefined ? (
                                <FormControl className={classes.formControl}>
                                    <InputLabel htmlFor="inventario-placeholder">
                                        Centro
                                </InputLabel>
                                    <Select
                                        native
                                        value={this.props.centroId}
                                        onChange={event =>
                                            this.handleChangeSelectCentro(event)
                                        }
                                    >
                                        {this.props.centros.find(
                                            c => c.id === this.props.centroId,
                                        ) === undefined ? (
                                                <option key={'centro_0'} value={0}>
                                                    {'Seleccione un centro'}
                                                </option>
                                            ) : (
                                                ''
                                            )}
                                        {this.centroSelectList()}
                                    </Select>
                                </FormControl>
                            ) : (
                                ''
                            )}

                        <FormControl className={classes.formControl}>
                            {/* <TextField
                                id={'fIni'}
                                label={'Fecha Inicio'}
                                placeholder={'Fecha Inicio'}
                                type="date2"
                                value={this.state.fIni}
                                onChange={(event) => this.handleValueChange(event, 'fIni')}
                                onKeyPress={(event) => {
                                    if (event.key === 'Enter') {
                                        this.handleValueChange(event, 'fIni');
                                        this.refresh(this.props.centroId, event.target.value, this.state.fEnd);
                                    };
                                }}
                            /> */}
                            <DatePicker
                                label={'Fecha Inicio'}
                                value={this.state.fIni}
                                onChange={event => {
                                    if (event && !isNaN(event)) {
                                        const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                        this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fIni')
                                    }
                                }}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        this.handleValueChangeDate(
                                            event,
                                            'fIni',
                                        );
                                        this.refresh(
                                            this.props.centroId,
                                            event.target.value,
                                            this.state.fEnd,
                                        );
                                    }
                                }}
                            />
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            {/* <TextField
                                id={'fEnd'}
                                label={'Fecha Fin'}
                                placeholder={'Fecha Fin'}
                                type="date2"
                                value={this.state.fEnd}
                                onChange={(event) => this.handleValueChange(event, 'fEnd')}
                                onKeyPress={(event) => {
                                    if (event.key === 'Enter') {
                                        this.handleValueChange(event, 'fEnd');
                                        this.refresh(this.props.centroId, this.state.fIni, event.target.value);
                                    };
                                }}
                            /> */}
                            <DatePicker
                                label={'Fecha Fin'}
                                value={this.state.fEnd}
                                onChange={event => {
                                    if (event && !isNaN(event)) {
                                        const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                        this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fEnd')
                                    }
                                }}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        this.handleValueChangeDate(
                                            event,
                                            'fEnd',
                                        );
                                        this.refresh(
                                            this.props.centroId,
                                            this.state.fIni,
                                            event.target.value,
                                        );
                                    }
                                }}
                            />
                        </FormControl>

                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                this.refresh(
                                    this.props.centroId,
                                    this.state.fIni,
                                    this.state.fEnd,
                                );
                            }}
                        >
                            Buscar
                        </Button>
                    </div>

                    <div style={{ marginBottom: 20 }}>
                        {this.state.inventarioList ? (
                                <NeuriteGrid
                                id="a_i"
                                    columns={[
                                        {
                                            key: 'ft_fInventario',
                                            name: 'Fecha Inv.',
                                            tooltip: 'Fecha del inventario',
                                            editable: false,
                                            dragable: false,
                                            width: 80,
                                        },
                                        {
                                            key: 'ft_fValidado',
                                            name: 'Fecha Valid.',
                                            tooltip: 'Fecha en que se validó el inventario',
                                            editable: false,
                                            dragable: false,
                                            width: 80,
                                        },
                                        {
                                            key: 'bCerrado',
                                            name: 'Cerrado',
                                            type: 'bool',
                                            editable: false,
                                            dragable: false,
                                            width: 60,
                                        },
                                        {
                                            key: 'ft_fCerrado',
                                            name: 'Fecha Cierre',
                                            tooltip: 'Fecha en que se cerró el inventario',
                                            editable: false,
                                            dragable: false,
                                            width: 80,
                                        },
                                    ]}
                                    rows={this.state.inventarioList}
                                    height={500}
                                    buttonEdit={true}
                                    buttonDelete={[0, 4, 5, 17, 20].includes(
                                        this.props.iPerfil,
                                    )} // fbp poner restricciones a borrar
                                    buttonNew={[16, 17].includes(this.props.iPerfil) ? false : true}
                                    onEditClick={this.editInventario}
                                    onNewRowClick={this.newInventario}
                                    onDeleteClick={this.deleteInventario}
                                />
                        ) : (
                                ''
                            )}
                    </div>
                </div>
            );
        }
    }
}

AccInventario.propTypes = {
    //state
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    // user ddw
    user: PropTypes.object.isRequired,
    centros: PropTypes.array.isRequired,
    centroId: PropTypes.number.isRequired,
    centroDescr: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centros: state.centros.centros,
        centroId: state.centroDiaSelected.centro.id,
        centroDescr: state.centroDiaSelected.centro.centro, // es la descripción del centro¡?
        iPerfil: state.userProfile.selectedCentroProfile.iPerfil,
        kd: state.userProfile.kd,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators(
        {
            navigate,
            setCentroDia,
            openDialog,
            hideDialog,
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispathToProps,
)(withStyles(styles, { withTheme: true })(AccInventario));
